// this file is automatically generated by git.revision.js script
export const versions = { revision: '545674bfee' }; 
 //expose the commit hash to the window object 
//@ts-ignore 
window.rd_version = '545674bfee';
